import axios from "axios";
import UseConfirm from "./UseConfirm";
import fileDownload from "js-file-download";
import {UseMessage} from "./UseMessage";


export const GetConfig = (headers, config) => {
    return {
        headers: {
            Source       : 'backend',
            Authorization: localStorage.getItem("_tkn"),
            ...headers
        },
        ...config
    };
};


export const UseGet = async (endpoint, params) => {
    let url
    const {data, headers, toArray, propValue, propLabel} = params

    if (data) {
        const query = data && Object.keys(data)
            .map(key => key + "=" + data[key])
            .join("&");

        url = `${process.env.REACT_APP_BASE_API + endpoint}${query ? "?" + query : ""}`
    } else {
        url = process.env.REACT_APP_BASE_API + endpoint
    }


    try {

        const response = (await axios.get(
            url, GetConfig(headers)
        )).data


        if (toArray) {
            if (response?.entities?.length > 0) {
                const output = []
                response.entities.map((entity) => {
                    output.push({
                        value: propValue ? entity[propValue] : entity._id.$oid,
                        label: propLabel ? entity[propLabel] : entity.title
                    })
                })

                return output
            }
        }

        return response


    } catch (error) {
        handleErrors(error);
        return error.response.data;
    }
};


export const UsePost = async (endpoint, params, options = {showMessage: true}) => {
    try {

        return (await axios.post(
            process.env.REACT_APP_BASE_API + endpoint,
            params?.data ? params.data : {}, GetConfig(params?.headers)
        )).data;

    } catch (error) {
        if (options?.showMessage) handleErrors(error);
        return error.response.data;
    }

};


export const UsePut = async (endpoint, params) => {
    const {data, headers, toArray, propValue, propLabel, keyValue, keyLabel} = params

    try {

        const response = (await axios.put(
            process.env.REACT_APP_BASE_API + endpoint,
            data ? data : {}, GetConfig(headers)
        )).data


        if (toArray) {
            const output = []

            if (response?.entities?.length > 0) {
                response.entities.map((entity) => {
                    const object = {}
                    object[keyLabel ? keyLabel : 'label'] = propLabel ? entity[propLabel] : entity.title
                    object[keyValue ? keyValue : 'value'] = propValue ? entity[propValue] : entity._id.$oid
                    output.push(object)
                })

                return output
            }
        }

        return response

    } catch (error) {
        if (toArray) {
            return []
        }
        handleErrors(error);
        return error.response.data;
    }
};

export const UsePatch = async (endpoint, params) => {
    try {

        return (await axios.patch(
            process.env.REACT_APP_BASE_API + endpoint,
            params?.data ? params.data : {}, GetConfig(params?.headers)
        )).data

    } catch (error) {
        return error.response.data
    }

};


export const UseDelete = async (endpoint, params) => {
    const {data, onConfirm, onSuccess, onError} = params

    const options = {
        data   : data,
        method : "delete",
        url    : process.env.REACT_APP_BASE_API + endpoint,
        headers: {
            Authorization: localStorage.getItem("_tkn")
        }
    }


    try {

        const response = (await axios(options)).data;

        if (response.code >= 200 && response.code < 299) {
            if (typeof onSuccess == "function") {
                onSuccess(response);
            }
        }

    } catch (error) {

        if (error.response.status === 428) {
            UseConfirm({
                title      : error.response.data.title,
                description: error.response.data.description,
                onConfirm  : async () => {

                    if (typeof onConfirm == "function") {
                        onConfirm(error.response.data);
                    }

                    options.data.force = 1

                    try {
                        const response = (await axios(options)).data;
                        if (response.code >= 200 && response.code < 299) {
                            if (typeof onSuccess == "function") {
                                onSuccess(response);
                            }
                        }
                    } catch (error) {
                        if (typeof onError == "function") {
                            onError(error)
                        }
                    }
                }
            });
        } else {
            return error
        }
    }

};


export const UseDownload = async (endpoint, params) => {
    const {data, headers} = params
    const requestData = data ? data : {}
    requestData.responseType = 'blob'

    try {

        const response = (await axios.put(
            process.env.REACT_APP_BASE_API + endpoint,
            requestData, GetConfig(headers),
        ))

        fileDownload(response.data, response.headers['filename']);

    } catch (error) {
        handleErrors(error);
        return error.response.data;
    }
};


const handleErrors = (error) => {
    toLoginIf(error, 401);
    showError(error);
};


const toLoginIf = (result, status) => {
    /*if (result.response.status === 401) {
      window.localStorage.removeItem("accessToken");
      window.location.href = `${process.env.PUBLIC_URL}/login`;
    }*/
};


const showError = (error) => {
    let message = "";

    if (error && error?.response?.data?.message) {
        message += error.response.data.message;
    }

    if (message !== "") {
        UseMessage('error', message)
    }
};


export const UseHttpMessages = (response, onSuccess, onError) => {
    if (response?.code >= 200 && response?.code <= 299) {
        if (typeof onSuccess === "function") {
            UseMessage('success', response.message)
            onSuccess()
        }
    } else {
        if (typeof onError === "function") {
            UseMessage('error', response.message)
            onError(response?.errors)
        }
    }

}

